import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3506b32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_ctx.className),
    name: _ctx.name
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}